export const SiteCache = {
    customUserFonts: []
};
